import { useState } from 'react';

// Read-only note text for the invoice side panels (2026-10-25): keeps line
// breaks (and the " | " separators PARAM appends), shows the first 2 lines
// with an inline "more" / "less" toggle when the note is longer.
export default function NoteText({ text, lines = 2, style }) {
  const [open, setOpen] = useState(false);
  if (!text) return null;
  const s = String(text).replace(/ \| (?=\[)/g, '\n');
  const long = s.split('\n').length > lines || s.length > 140 * lines;
  const clamp = long && !open
    ? { display: '-webkit-box', WebkitLineClamp: lines, WebkitBoxOrient: 'vertical', overflow: 'hidden' }
    : {};
  return (
    <div style={{ fontSize: 11, color: 'var(--muted)', marginTop: 4, ...style }}>
      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', ...clamp }}>{s}</div>
      {long && (
        <button type="button" className="btn btn-ghost btn-sm" style={{ padding: '0 4px', fontSize: 11 }}
          onClick={() => setOpen(o => !o)}>
          {open ? 'less' : 'more'}
        </button>
      )}
    </div>
  );
}

// The invoice's own notes and (AP) its queue note, shown above the payments
// list. A queue note starting "HOLD" is highlighted - it is why the invoice is
// held out of the Payments Queue.
export function InvoiceNotes({ notes, queueNote }) {
  if (!notes && !queueNote) return null;
  const isHold = queueNote && /^HOLD/i.test(queueNote);
  return (
    <div style={{ marginBottom: 14 }}>
      {queueNote && (
        <div style={{
          fontSize: 12, padding: '8px 10px', borderRadius: 'var(--radius)', marginBottom: 8,
          background: isHold ? '#f59e0b22' : '#0ea5e922', border: `1px solid ${isHold ? '#f59e0b66' : '#0ea5e944'}`,
          color: isHold ? '#b45309' : '#0284c7', fontWeight: isHold ? 600 : 400,
        }}>
          {isHold ? '⏸ ' : ''}{queueNote}
        </div>
      )}
      {notes && (
        <div style={{ background: 'var(--surface)', borderRadius: 'var(--radius)', padding: 10 }}>
          <div style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 600 }}>Invoice notes</div>
          <NoteText text={notes} lines={3} />
        </div>
      )}
    </div>
  );
}
